export const en = {
    nothing_found: 'Nothing found',
};
